import { Typography } from '@analytical-alley/ui';
import React from 'react';

export type MarkPointData = { coord: [number, number]; name: string; symbol: string; };
export const MarkPointTooltip = ({
    name,
    data,
    investmentFormatter,
    contributionFormatter,
}: {
    name: string;
    data: MarkPointData;
    investmentFormatter?: (value: string | undefined | number) => string;
    contributionFormatter?: (value: string | undefined | number) => string;
}) => {
    return (
        <div className="tooltip-content-md">
            <Typography className="text-dark dark:text-dark">
                {name} -{' '}
                {data.symbol === 'circle' ? 'Previous value' : 'Recommended'}
            </Typography>
            <table className="font-sans">
                <tbody>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Investment:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {investmentFormatter
                                    ? investmentFormatter(data.coord[0])
                                    : data.coord[0]}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Contribution:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {contributionFormatter
                                    ? contributionFormatter(data.coord[1])
                                    : data.coord[1]}
                            </Typography>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
